import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text, Box } from "@similarweb/ui-components/foundations";

import { openHooksModalV5 } from "app/services/ModalService";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const LockedState = () => {
    const t = useTranslation();

    const openTrialModal = () => {
        openHooksModalV5("MarketAnalysis");
    };

    return (
        <Box padding="8px">
            <Flex
                flexDirection="column"
                padding="16px"
                gap="16px"
                background={colorsPalettes.indigo[50]}
            >
                <Flex
                    flexDirection="column"
                    gap="8px"
                >
                    <Text fontVariant="subtitle2">{t("autocomplete.market.tab.locked.hook.title")}</Text>
                    <Text fontVariant="input2">{t("autocomplete.market.tab.locked.hook.subtitle")}</Text>
                </Flex>
                <Flex justifyContent="flex-end">
                    <IconButton
                        type="trial"
                        iconName="sparkles"
                        onClick={openTrialModal}
                    >
                        {t("autocomplete.market.tab.locked.hook.title")}
                    </IconButton>
                </Flex>
            </Flex>
        </Box>
    );
};
